import React from "react";
import { motion } from "framer-motion";
import apppre from '../assets/app.png'

const features = [
  {
    title: "Real-time Messaging",
    description:
      "Connect with mentors, investors, and other founders instantly.",
    icon: "https://cdn.lordicon.com/kthelypq.json", // chat
  },
  {
    title: "Event Discovery",
    description:
      "Find and register for networking events, workshops, and conferences.",
    icon: "https://cdn.lordicon.com/abfverha.json", // calendar
  },
  {
    title: "Startup Dashboard",
    description:
      "Track your progress, manage tasks, and view analytics on the go.",
    icon: "https://cdn.lordicon.com/dxjqoygy.json", // dashboard
  },
];

const AppPreview = () => {
  return (
    <section className="bg-gray-50 py-14 px-4" id="app-preview">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 items-center gap-10">
        {/* Left Text & Features */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
            App Preview
          </h2>
          <p className="text-gray-600 mb-6 text-sm md:text-base">
            Take your startup journey on the go with our mobile app. Connect,
            learn, and grow from anywhere.
          </p>

          <h3 className="font-semibold mb-4 text-lg">
            Everything You Need in One App
          </h3>

          <div className="space-y-5">
            {features.map((item, index) => (
              <div
                key={index}
                className="flex items-start space-x-4 group cursor-pointer"
              >
                <div className="bg-blue-100 p-2 rounded-full">
                  <lord-icon
                    src={item.icon}
                    trigger="hover"
                    style={{ width: "32px", height: "32px" }}
                  />
                </div>
                <div>
                  <h4 className="font-semibold text-sm md:text-base">
                    {item.title}
                  </h4>
                  <p className="text-gray-600 text-sm">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        {/* Right Image */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="flex justify-center"
        >
          <div className="bg-blue-100 p-4 rounded-2xl shadow-md">
            <img
              src= {apppre}
              alt="App Preview"
              className="w-[220px] md:w-[260px] lg:w-[300px] rounded-xl"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AppPreview;
